import { inputField } from '@/ui/components/form';
import { t } from '@/ui/i18n/i18n';
import { ComputedRef, Ref } from 'vue';
import { SsoConfiguration } from '@/entities/sso-configuration';
import { Task } from '@/ui/concerns';
import { ValidationError } from '@/entities/validation';
import { SamlConfiguration } from '@/services/api/resources/sso-configuration';
import { uploadField } from '@/ui/components/form/UploadField';

export const SamlFormFields = (record: Ref<SsoConfiguration>, validationErrors: ComputedRef<ValidationError[]>, task: Task) => {
  const configuration = <SamlConfiguration>(record.value.configuration);

  return [
    inputField(
      {
        name: 'configuration.entityId',
        label: t('sso.entity-id'),
        tooltipText: t('sso.tooltips.entity-id'),
        value: configuration.entityId || '',
        placeholder: t('sso.entity-id'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.entityId = value;
      },
    ),
    inputField(
      {
        name: 'configuration.nameIdFormat',
        label: t('sso.name-id-format'),
        tooltipText: t('sso.tooltips.name-id-format'),
        value: configuration.nameIdFormat || 'urn:oasis:names:tc:SAML:1.1:nameid-format:emailAddress',
        placeholder: t('sso.name-id-format'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.nameIdFormat = value;
      },
    ),
    inputField(
      {
        name: 'configuration.authorizationUri',
        label: t('sso.saml-authorization-uri'),
        tooltipText: t('sso.tooltips.saml-authorization-uri'),
        value: configuration.authorizationUri || '',
        placeholder: t('sso.saml-authorization-uri'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.authorizationUri = value;
      },
    ),
    inputField(
      {
        name: 'configuration.singleSignOnService',
        label: t('sso.single-sign-on-service'),
        tooltipText: t('sso.tooltips.single-sign-on-service'),
        value: configuration.singleSignOnService || '',
        placeholder: t('sso.single-sign-on-service'),
        required: true,
        errors: validationErrors.value,
        disabled: task.state.value.pending,
      },
      value => {
        configuration.singleSignOnService = value;
      },
    ),
    uploadField(
      {
        name: 'configuration.certificate',
        type: 'is-primary is-outlined',
        label: t('sso.certificate'),
        buttonLabel: configuration.certificate ? t('sso.replace-certificate') : t('sso.upload-certificate'),
        accept: '.cert,.crt,.pem',
        tooltipText: t('sso.tooltips.certificate'),
        required: false,
        value: configuration.certificate,
      },
      value => {
        configuration.certificate = value;
      },
    ),
  ];
};
